import VehicleNotesModal from '../modal/VehicleNotesModal';

export default function ShareComponent() {
    return (
        <>
            <VehicleNotesModal/>
        </>
    )
}